import userStore from '@/stores/user/index';

// 获取 hq_ui_optimisation 实验组

export enum HQ_UI_OPTIMISATION_GROUP {
  CONTROL = 'control',
  THREE_PL_NAME = '3pl_name',
  EDD_THREE_PL_NAME = 'edd_3pl_name',
  EDD = 'edd',
};

const getHqUIOptimisationGroup = () => {
  const controlGroup = (userStore.newABTestingConfigs as any)?.hq_ui_optimisation;
  return controlGroup ?? HQ_UI_OPTIMISATION_GROUP.CONTROL;
};

export default getHqUIOptimisationGroup;
